<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Notes') }}</Tab>
                <Tab value="2">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="opportunity_name"
                                       label="Opportunity name"
                                       validation="required"
                                       size="10"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.opportunity_name" />
                        <FormInputText fieldName="opportunity_number"
                                       label="Number"
                                       size="2"
                                       :isFormDisabled="true"
                                       v-model:field="crud.opportunity_number" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="dctpriority_id"
                                    label="Priority"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_opportunity_priorities"
                                    v-model:field="crud.dctpriority_id" />

                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />

                        <template v-if="isSuspendedStatus">
                            <FormSelect fieldName="dctsuspendreason_id"
                                        label="Suspended reason"
                                        size="4"
                                        :isFormDisabled="isFormDisabled"
                                        :options="select?.dct_opportunity_suspended"
                                        v-model:field="crud.dctsuspendreason_id" />
                        </template>
                        <template v-if="isLostStatus">
                            <FormSelect fieldName="dctlostreason_id"
                                        label="Lost reason"
                                        size="4"
                                        :isFormDisabled="isFormDisabled"
                                        :options="select?.dct_opportunity_lost"
                                        v-model:field="crud.dctlostreason_id" />
                        </template>
                    </div>

                    <div class="grid">
                        <FormSelect fieldName="contractor_id"
                                    label="Contractor"
                                    size="4"
                                    showClear
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.contractors"
                                    v-model:field="crud.contractor_id" />

                        <FormSelect fieldName="lead_id"
                                    label="Lead"
                                    size="3"
                                    showClear
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.leads"
                                    v-model:field="crud.lead_id" />

                        <FormRadioButton fieldName="service_type"
                                         label="Service type"
                                         validation="required"
                                         size="1"
                                         containerClass="radio-button"
                                         optionClass="radio-button-option"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.service_types"
                                         :change="serviceTypeChanged"
                                         v-model:field="crud.service_type" />

                        <FormSelect fieldName="service_id"
                                    label="Service"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.services"
                                    v-model:field="crud.service_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="trader_id"
                                    label="Trader"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.trader_id" />

                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />

                        <FormInputNumber fieldName="budget_assumed"
                                         label="Budget assumed"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.budget_assumed" />

                        <FormInputNumber fieldName="sales_potential"
                                         label="Sales potential"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.sales_potential" />
                    </div>
                    <template v-if="isAfterNeedsAnalysisStatus">
                        <div class="grid">
                            <FormInputNumber fieldName="budget_real"
                                             label="Real budget"
                                             size="2"
                                             :minFractionDigits="2"
                                             :maxFractionDigits="2"
                                             :isFormDisabled="isFormDisabled"
                                             v-model:field="crud.budget_real" />
                            <FormInputText fieldName="location"
                                           label="Location"
                                           size="5"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.location" />
                            <FormInputText fieldName="surface"
                                           label="Surface"
                                           size="5"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.surface" />
                        </div>
                        <div class="grid">
                            <FormCalendar fieldName="start_date"
                                          label="Start date"
                                          size="4"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.start_date" />

                            <FormCalendar fieldName="expected_closing_date"
                                          label="Expected closing date"
                                          size="4"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.expected_closing_date" />

                            <FormCalendar fieldName="nearest_contact_date"
                                          label="Nearest contact date"
                                          size="4"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.nearest_contact_date" />
                        </div>
                    </template>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Documents"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel value="1">
                    <div class="grid">
                        <FormRepeaterTable v-model:record="crud.opportunity_users"
                                           :keys="{ 'user_id': null, 'note': null, 'note_date': null }"
                                           :isFirstRowEmpty="false"
                                           :isCopyButton="false"
                                           repeaterStyle="margin-top:5px;width:95%"
                                           name="opportunity_users"
                                           :title="[__('User'), __('Note'), __('Note date')]">
                            <template #repeat="slotProps">
                                <td style="width:25%;"
                                    :style="slotProps.cellStyle">
                                    <FormSelect fieldName="user_id"
                                                :inRepeater="true"
                                                :options="select?.users"
                                                v-model:field="slotProps.record.user_id" />
                                </td>
                                <td style="width:60%"
                                    :style="slotProps.cellStyle">
                                    <FormTextarea fieldName="note"
                                                  :inRepeater="true"
                                                  :rows="2"
                                                  v-model:field="slotProps.record.note" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormCalendar fieldName="note_date"
                                                  :inRepeater="true"
                                                  v-model:field="slotProps.record.note_date" />
                                </td>
                            </template>
                        </FormRepeaterTable>
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="2"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-show="buttonProps">
                    <span style="margin-right:25px"></span>
                    <span v-if="!isLostStatus">
                        <CustomButton v-if="isRecognitionStatus"
                                      name="needAnalysis"
                                      @click.stop="addNeedAnalysis"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('teal')">
                            <template class="flex items-center gap-1"><i class="fa-regular fa-circle-xmark"></i><span>{{ __('Need analysis') }}</span></template>
                        </CustomButton>
                    </span>

                    <span v-if="!isLostStatus">
                        <CustomButton v-if="isAfterNeedsAnalysisStatus"
                                      name="createOffer"
                                      @click.stop="createOffer"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-tags"></i><span>{{ __('Create offer') }}</span></template>
                        </CustomButton>
                    </span>

                    <span v-if="!isLostStatus && !isWonStatuses">
                        <CustomButton name="setStatus"
                                      @click.stop="setStatus"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('green')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-traffic-light"></i><span>{{ __('Set status') }}</span></template>
                        </CustomButton>
                    </span>

                    <span v-if="isOfferCreated">
                        <CustomButton name="showOffers"
                                      @click.stop="showOffers"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-folder-open"></i><span>{{ __('Show offers') }}</span></template>
                        </CustomButton>
                    </span>
                </template>

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'opportunities', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

    <Dialog modal
            v-model:visible="isSetNeedAnalysisModalOpen"
            :header="__('Need analysis')"
            :unstyled="false"
            :style="{ width: '50%' }"
            :pt="dialogPt">
        <NeedAnalysisForm :opportunityData="opportunityData"
                          :formProps="opportunityFormProps"
                          :statuses="select?.statuses"
                          v-model:isSetNeedAnalysisModalOpen="isSetNeedAnalysisModalOpen">
        </NeedAnalysisForm>
    </Dialog>

    <Dialog modal
            v-model:visible="isCreateOfferModalOpen"
            :header="__('Creating offer')"
            :unstyled="false"
            :style="{ width: '90%' }"
            :pt="dialogPt">
        <OfferForm :opportunityData="opportunityData"
                   :formProps="opportunityFormProps">
        </OfferForm>
    </Dialog>

    <Dialog modal
            v-model:visible="isSetStatusModalOpen"
            :header="__('Setting status')"
            :unstyled="false"
            :style="{ width: '40%' }"
            :pt="dialogPt">
        <SetStatusForm :opportunityData="opportunityData"
                       :formProps="opportunityFormProps"
                       :opportunity_id="crud.id"
                       :statuses="select?.statuses"
                       :dctSuspended="select.dct_opportunity_suspended"
                       :dctLost="select.dct_opportunity_lost"
                       v-model:isSetStatusModalOpen="isSetStatusModalOpen">
        </SetStatusForm>
    </Dialog>

</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { router } from "@inertiajs/vue3";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormRadioButton from '@crud/FormRadioButton.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import CustomButton from '@crud/CustomButton.vue'
import Dialog from 'primevue/dialog';
import NeedAnalysisForm from './NeedAnalysisForm.vue'
import OfferForm from '../Offer/OfferForm.vue'
import SetStatusForm from './SetStatusForm.vue'
import { validation, initFormObj, prepareSelect, prepareCrud } from '@pages/Helper/crud_utils.js'
import { __, getAllStatuses, getStatusId, getStoreValue, getFromRoute, buttonClass } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref(null);

const options = ["statuses", "contractors", "leads", "dct_opportunity_priorities", "dct_opportunity_suspended", "dct_opportunity_lost", "service_types", "services", "users"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

const isLostStatus = ref(false)
const isSuspendedStatus = ref(false)
const isRecognitionStatus = ref(false)
const isAfterNeedsAnalysisStatus = ref(false)
const isWonStatuses = ref(false)
const isOfferCreated = ref(false)

const opportunityData = ref({})
const opportunityFormProps = ref({})

const isSetNeedAnalysisModalOpen = ref(false);
const isCreateOfferModalOpen = ref(false);
const isSetStatusModalOpen = ref(false);

const allStatuses = ref([])
const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, buttonsVisibility, paramsToSelect: { 'statuses': { 'status_category': 'STA_OPPORTUNITY' } } })
    serviceTypeChanged();
    checkIfOfferCreated()

    if (props.formProps.addMode == true) {
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = await getStatusId('STA_OPPORTUNITY', 'SYM_RECOGNITION');
    } else {
        allStatuses.value = await getAllStatuses('STA_OPPORTUNITY');

        isRecognitionStatus.value = allStatuses.value.some(status => status.id === crud.value.status_id && status.status_symbol === 'SYM_RECOGNITION');
        isLostStatus.value = allStatuses.value.some(status => status.id === crud.value.status_id && status.status_symbol === 'STA_LOST');
        isSuspendedStatus.value = allStatuses.value.some(status => status.id === crud.value.status_id && status.status_symbol === 'SYM_SUSPENDED');
        isWonStatuses.value = allStatuses.value.some(status => status.id === crud.value.status_id && status.status_symbol === 'SYM_WON');
        isAfterNeedsAnalysisStatus.value = allStatuses.value.some(status => status.id === crud.value.status_id && ['SYM_NEEDS_ANALYSIS', 'SYM_PRESENTED_PRESENTATION', 'SYM_CREATED_OFFER', 'SYM_SENT_OFFER', 'SYM_NEGOTIATIONS', 'SYM_WON', 'SYM_SUSPENDED'].includes(status.status_symbol));
    }
})

// -----------------------------------------------------

const serviceTypeChanged = async () => {
    const options = await prepareSelect(['services'], null, null, { 'services': { 'type': crud.value.service_type ??= 'O' } })
    select.value.services = options.services
}

// -----------------------------------------------------

const addNeedAnalysis = async () => {
    opportunityData.value = { ...crud.value }
    opportunityFormProps.value = props.formProps
    isSetNeedAnalysisModalOpen.value = true;
}

// -----------------------------------------------------

const createOffer = async () => {
    opportunityData.value = { ...crud.value }
    opportunityFormProps.value = {
        formName: 'offer-form',
        addMode: true,
        routes: {
            store: 'offer-store',
        },
        closeModal: () => isCreateOfferModalOpen.value = false,
        getLazyData: async () => {
            crud.value = await prepareCrud(props)
            checkIfOfferCreated()
        }
    }
    isCreateOfferModalOpen.value = true;
}

// -----------------------------------------------------

const showOffers = () => {
    router.visit(route('offer-index', { opportunity_id: crud.value.id }), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// -----------------------------------------------------

const setStatus = async () => {
    opportunityData.value = { ...crud.value }
    opportunityFormProps.value = props.formProps
    isSetStatusModalOpen.value = true;
}

// -----------------------------------------------------

const checkIfOfferCreated = () => {
    isOfferCreated.value = crud.value.offers && crud.value.offers.length > 0
}

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
